import { systemFontStack } from "../utils/AdaptiveUiThemeStyle";
import "../style/avbase-fonts.scss";
/**
 * Asplan Viak base theme (new component library)
 */
export const avbase = {
    name: "avbase",
    fontStack: `Mulish, ${systemFontStack}`,
    fontWeight: 400,
    headingFontWeight: 600,
    defaultTextColor: "#212121",
    labelTextColor: "#414141",
    headingTextColor: "#000000",
    primary: "#1d3c34",
    secondary: "#0c2433",
    tertiary: "#9bc687",
    success: "#448537",
    warning: "hsl(39, 80%, 57%)",
    danger: "hsl(4, 65%, 50%)",
    dark: "#232420",
    medium: "#dae1d6",
    light: "#f6f8f7",
    linkTextColor: "#1d3c34",
    radius: 8,
    defaultSpacing: 5,
    largeButtonRadius: 43,
    buttonRadius: 43,
    smallButtonRadius: 43,
    buttonBorderWidth: 0,
    buttonGap: 8,
    buttonPadding: "12px 24px",
    smallButtonPadding: "6px 12px",
    largeButtonPadding: "15px 30px",
    inputRadius: 6,
    checkboxRadius: 4,
    inputPadding: ".75em",
    inputBackground: "#fff",
    inputBorderColor: "#9E9E9E",
    inputBorderColorSingle: "#9E9E9E",
    inputTextColor: "#212121",
    inputBorderWidth: 1,
    inputShadowBlur: 0,
    inputShadowOffset: "0 0",
    optionPadding: "12px 24px",
    overrides: {
        "--checkmark-checked-background": "var(--primary)",
        "--checkmark-checked-color": "var(--primary-contrast)",
        "--checkmark-size": "1.25em",
        "--rich-text-toolbar-btn-radius": "2px",
    },
};
